export default "__VITE_ASSET__CB3kj1cj__"